import type { CVEditingSection, FullCV } from '@cibli/shared';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';

interface HobbiesAndInterestsProps {
  hobbiesAndInterests: FullCV['hobbiesAndInterests'];
  accent: string;
  onEdit?: (section: CVEditingSection) => void;
}

export default function HobbiesAndInterests({
  hobbiesAndInterests,
  accent,
  onEdit,
}: HobbiesAndInterestsProps) {
  const { t } = useCVTranslation();
  const handleEdit = () => onEdit && onEdit('hobbiesAndInterests');
  const editable = onEdit !== undefined;

  if (!hobbiesAndInterests?.length && !editable) return null;

  return (
    <EditableSection onEdit={handleEdit} editable={editable} accentColor={accent}>
      <div className="rounded-lg border p-2.5">
        <h2 className="text-[11px] font-black uppercase tracking-widest text-black">
          {t('CV.hobbiesAndInterests')}
        </h2>
        <ul className="mt-1 space-y-1">
          {(hobbiesAndInterests ?? []).map((h, i) => (
            <li key={i} className="text-[11px] font-semibold">
              • {h}
            </li>
          ))}
        </ul>
      </div>
    </EditableSection>
  );
}
